export default {
  title: 'Winkelwagen',
  buttons: {
    login_to_checkout: 'Inloggen om af te rekenen',
    checkout: 'Afrekenen',
  },
  go_to_menu: 'Naar menu',
  toasts: {
    cashback_points_removed: 'Je puntensaldo is gewijzigd, dus we hebben de punten van deze bestelling verwijderd.',
  },
};
